import { render, staticRenderFns } from "./LaudoListagemDashboard.vue?vue&type=template&id=3d884d7b&lang=pug"
import script from "./LaudoListagemDashboard.vue?vue&type=script&lang=js"
export * from "./LaudoListagemDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports